"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIMPLEX_LINKS = exports.CTCP_TYPE = exports.CTCP_REQUEST = void 0;
exports.copySimplexAddress = copySimplexAddress;
exports.getRemoteSimplexAddress = getRemoteSimplexAddress;
exports.getSimplexAddress = getSimplexAddress;
exports.isSimplexAddress = isSimplexAddress;
exports.parseSimplexCtcp = parseSimplexCtcp;
exports.saveSimplexAddress = saveSimplexAddress;
exports.setRemoteSimplexAddress = setRemoteSimplexAddress;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/url"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var STORAGE_KEY = 'kiwi.simplexAddress';
var remoteAddresses = new _map.default();
var CTCP_TYPE = 'SIMPLEX';
exports.CTCP_TYPE = CTCP_TYPE;
var CTCP_REQUEST = 'REQUEST';
exports.CTCP_REQUEST = CTCP_REQUEST;
function remoteAddressKey(networkId, nick) {
  var _context;
  return (0, _concat.default)(_context = "".concat(networkId, ":")).call(_context, (nick || '').toLowerCase());
}

// Keep these in one place so a deployment can replace them with its own
// official channel and community group without touching the UI components.
var SIMPLEX_LINKS = {
  downloads: 'https://simplex.chat/downloads/',
  android: 'https://play.google.com/store/apps/details?id=chat.simplex.app',
  ios: 'https://apps.apple.com/app/simplex-chat/id1605771084'
  // officialChannel: 'https://t.me/simplex_chat',
};
exports.SIMPLEX_LINKS = SIMPLEX_LINKS;
function isSimplexAddress(value) {
  var _context2;
  var address = (0, _trim.default)(_context2 = value || '').call(_context2);
  if (!address || address.length > 300 || /[\s\u0000-\u001f\u007f]/.test(address)) {
    return false;
  }
  if (/^simplex:/i.test(address)) {
    return true;
  }
  try {
    var url = new _url.default(address);
    return url.protocol === 'https:' && !!url.hostname && url.hash.length > 1;
  } catch (err) {
    return false;
  }
}
function parseSimplexCtcp(message) {
  var _context3, _context4;
  var value = (0, _trim.default)(_context3 = message || '').call(_context3);
  value = value.replace(/^\u0001|\u0001$/g, '');
  value = value.replace(/^\\(?:x01|001)/i, '').replace(/\\(?:x01|001)$/i, '');
  var match = value.match(/^SIMPLEX(?:\s+([\s\S]*?))?$/i);
  if (!match) {
    return null;
  }
  return {
    type: CTCP_TYPE,
    message: (0, _trim.default)(_context4 = match[1] || '').call(_context4)
  };
}
function getSimplexAddress() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) || '';
  } catch (err) {
    return '';
  }
}
function saveSimplexAddress(value) {
  var _context5;
  var address = (0, _trim.default)(_context5 = value || '').call(_context5);
  if (!address) {
    window.localStorage.removeItem(STORAGE_KEY);
    return '';
  }
  if (!isSimplexAddress(address)) {
    throw new Error('Inserisci un link di contatto SimpleX valido.');
  }
  window.localStorage.setItem(STORAGE_KEY, address);
  return address;
}
function getRemoteSimplexAddress(networkId, nick) {
  return remoteAddresses.get(remoteAddressKey(networkId, nick)) || '';
}
function setRemoteSimplexAddress(networkId, nick, address) {
  var _context6;
  var normalized = (0, _trim.default)(_context6 = address || '').call(_context6);
  if (!isSimplexAddress(normalized)) {
    return false;
  }
  remoteAddresses.set(remoteAddressKey(networkId, nick), normalized);
  return true;
}
function copySimplexAddress(address) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(address);
  }
  var input = document.createElement('textarea');
  input.value = address;
  input.setAttribute('readonly', '');
  input.style.position = 'absolute';
  input.style.left = '-9999px';
  document.body.appendChild(input);
  input.select();
  document.execCommand('copy');
  document.body.removeChild(input);
  return _promise.default.resolve();
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["Simplex"]
window._kiwi_exports.libs.Simplex = exports.default ? exports.default : exports;
